import { FRAGNO1_RESOLVED } from '../actions/fragno1';

// The fragno1 flag as resolved once at boot (fragno1/loadFragno1Flag.js). Kept apart from
// featureFlags so a later /feature_flags response can't swap flagged UI mid-page.
export const initialState = {
  on: false,
  source: null,
};

const fragno1 = (state = initialState, action = {}) => {
  switch (action.type) {
    case FRAGNO1_RESOLVED:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const selectFragno1 = (state) => state.fragno1.on;

export default fragno1;
